<template><div><h1>Vue 应用中使用微信 jssdk</h1>
<div class="warning">
<p>分享接口只有认证公众号才能使用，域名必须备案且在微信后台设置。</p>
<p>先确认已经满足使用<code>jssdk</code>的要求再进行开发。</p>
</div>
<p><code>WechatPlugin</code> 插件提供了<code>commonJS</code>的引入方式，因此你不需要在 <code>index.html</code> 引入文件。</p>
<h2>版本要求</h2>
<p><code>WechatPlugin</code>在<code>vux@^2.1.0-rc.19</code>开始支持</p>
<h2>引入</h2>
<p>在 <code>main.js</code> 中全局引入：</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { WechatPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(WechatPlugin)

<span class="hljs-built_in">console</span>.log(Vue.wechat) <span class="hljs-comment">// 可以直接访问 wx 对象。</span>
</code></pre>
<h2>组件外使用</h2>
<p>考虑到你需要在引入插件后调用<code>config</code>方法进行配置，你可以通过 <code>Vue.wechat</code> 在组件外部访问<code>wx</code>对象。</p>
<p><code>jssdk</code>需要请求签名配置接口，你可以直接使用 VUX 基于 <code>Axios</code> 封装的 <code>AjaxPlugin</code>。</p>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { WechatPlugin, AjaxPlugin } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>
Vue.use(WechatPlugin)
Vue.use(AjaxPlugin)

Vue.http.get(<span class="hljs-string">'/api'</span>, ({data}) =&gt; {
  Vue.wechat.config(data.data)
})
</code></pre>
<h2>组件中使用</h2>
<p>那么之后任何组件中都可以通过 <code>this.$wechat</code> 访问到 <code>wx</code> 对象。</p>
<pre class="hljs"><code><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  created () {
    <span class="hljs-keyword">this</span>.$wechat.onMenuShareTimeline({
      <span class="hljs-attr">title</span>: <span class="hljs-string">'hello VUX'</span>
    })
  }
}
</code></pre>
</div></template><script>
export default {
  head: {"title":"Vue 应用中使用微信 jssdk | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// vue-wechat-jssdk-315.vue?39be85df